import { useNavigate, useParams } from "react-router-dom";
import { useDevice } from "../../hooks";
import { Breadcrumb, Col, Empty, Pagination, Row, Tag, Button } from "antd";
import { useEffect, useState } from "react";
import { getByCategorySlug } from "../../api/blog";
import dayjs from "dayjs";
import { ArrowLeftOutlined, ArrowRightOutlined, CalendarOutlined } from "@ant-design/icons";

export default function CategoryBlogDetail() {
    const param = useParams();
    const navigate = useNavigate();
    const { isMobile } = useDevice();
    const [blog, setBlog] = useState();
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 12,
    });

    useEffect(() => {
        getByCategorySlug(param?.slug, pagination, setBlog);
    }, [pagination, param?.slug])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const categoryTitle = blog?.data?.[0]?.category_blog_name || param?.slug;

    return (
        <div className={`min-h-screen bg-gray-50 pb-20 ${isMobile && ""}`}>
            {/* Header Section */}
            <div className="bg-gradient-to-b from-blue-50 to-gray-50 pt-4 md:pt-10">
                <div className="max-w-screen-2xl mx-auto px-4 md:px-10">
                    <Breadcrumb
                        className="mb-8"
                        items={[
                            { title: <a href="/">Trang chủ</a> },
                            { title: <a href="/blog">Blog</a> },
                            { title: <span className="font-semibold">{categoryTitle}</span> }
                        ]}
                    />

                    <div className="flex flex-col items-center text-center mt-5">
                        <Tag color="blue" className="mb-6 rounded-full px-5 py-1.5 font-black uppercase tracking-[0.2em] text-[10px] border-none bg-blue-100 text-blue-700 shadow-sm">
                            Khám phá danh mục
                        </Tag>
                        <h1 className="text-4xl md:text-6xl font-black text-gray-900 tracking-tighter leading-none">
                            {categoryTitle}
                        </h1>
                        <div className="w-24 h-1.5 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full shadow-lg shadow-blue-200"></div>
                    </div>
                </div>
            </div>

            <div className="max-w-screen-2xl mx-auto px-2 md:px-10 mt-5">
                <div className="bg-white rounded-[2rem] p-4 md:p-10 shadow-xl border border-blue-50/50 min-h-[600px]">
                    <div className="flex items-center justify-between mb-10 border-b border-gray-100 pb-6">
                        <h2 className="text-xl md:text-2xl font-bold text-gray-800">Bài viết trong danh mục</h2>
                        <span className="text-gray-400 font-medium text-xs md:text-base">{blog?.total || 0} bài viết</span>
                    </div>

                    {blog?.data?.length > 0 ? (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-10">
                            {blog?.data?.map((_, i) => (
                                <a
                                    key={i}
                                    href={`/blog/${_?.blog_slug}`}
                                    className="group block bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-blue-100"
                                >
                                    <div className="relative overflow-hidden aspect-[16/10]">
                                        <img
                                            src={_?.blog_image}
                                            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                                            alt={_?.blog_name}
                                        />
                                    </div>
                                    <div className="p-8">
                                        <div className="flex items-center gap-2 text-gray-400 text-xs mb-3">
                                            <CalendarOutlined />
                                            <span>{dayjs(_?.create_at).format("DD/MM/YYYY")}</span>
                                        </div>
                                        <h3 className="text-xl font-bold text-gray-800 mb-3 line-clamp-2 h-14 group-hover:text-blue-600 transition-colors">
                                            {_?.blog_name}
                                        </h3>
                                        <div
                                            className="sun-editor-editable html-preview text-gray-500 text-sm line-clamp-2 mb-6 font-light h-10"
                                            dangerouslySetInnerHTML={{ __html: _?.blog_description || "" }}
                                        />
                                        <div className="flex items-center text-blue-600 font-bold text-sm gap-1 group-hover:gap-3 transition-all">
                                            Chi tiết <ArrowRightOutlined />
                                        </div>
                                    </div>
                                </a>
                            ))}
                        </div>
                    ) : (
                        <div className="py-20 flex flex-col items-center">
                            <Empty description="Danh mục này hiện chưa có bài viết nào" />
                            <Button type="primary" size="large" onClick={() => navigate('/blog')} className="mt-6 rounded-xl px-10">
                                Tìm bài viết khác
                            </Button>
                        </div>
                    )}

                    {blog?.total > pagination.pageSize && (
                        <div className="mt-16 flex justify-center">
                            <Pagination
                                current={pagination.page}
                                total={blog?.total}
                                pageSize={pagination.pageSize}
                                className="custom-pagination"
                                onChange={(p, ps) => {
                                    setPagination({
                                        page: p,
                                        pageSize: ps
                                    })
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                }}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

